<template>
  <div>
    <h2>Disk Images:</h2>
    <p>These are for full fresh disk installations</p>
    <a href="/favicon.png" download="GoLive-v1.0.0-alpha.img">v1.0.0-alpha.img</a>

    <h2>GoLive Software Only</h2>
    <p>For manual software updates</p>

    <a href="/favicon.png" download="download">Version v0.1.0 </a>
    <br />
    <a href="/favicon.png" download="download">Version v0.2.0</a>
    <br />
    <a href="/favicon.png" download="download">Version v0.3.0</a>
    <br />
    <a href="/favicon.png" download="download">Version v1.0.0</a>
    <br />
  </div>
</template>

<script>
export default {
  name: "Login",
  props: {},

  data() {
    return {
      username: "",
      password: "",
      error: "",
      loading: false,
    };
  },

  methods: {},

  components: {},
};
</script>
